import { Field, Form, FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaEye, FaDownload, FaCheckCircle } from "react-icons/fa";
import ShiftingPdfViewer from "../UniversityScreens/ShiftingPdfViewer";
import { generateDeficienciesPdf } from "../../PdfGenerate";
import { useNavigate } from "react-router-dom";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { viewImage } from "../../CommonUtils/viewImage";
import { downloadBase64Pdf, ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { CollegeReport } from "../UniversityScreens/CollegeReport";
import { FaCheck } from "react-icons/fa";
import { openScrutinyPdfInNewTab } from "../UniversityScreens/ScrutinityPdfGeneration";
import { openChangeOfManagementPdfInNewTab } from "../UniversityScreens/PdfForChangeofManagement";
import NewCollegeApplPreview from "../NewCollegeApplPreview";

export default function DeficiencyInspectionStatus() {
  const [selecteddRow, setSelecteddRow] = useState(null);
  const [showShiftinggModal, setShowShiftinggModal] = useState(false);
  const [selectedColCode, setSelectedColCode] = useState(null);
  const [pdfData1, setPdfData1] = useState({});
  const [societyName, setSocietyName] = useState([]);
  const [managementData, setManagementData] = useState([]);
  const [nocdta, setNocdta] = useState({});
  const [showPreview, setShowPreview] = useState(false);

  const [pdffData2, setPdffData2] = useState({});
  const [pdffData3, setPdffData3] = useState({});

  const [ScrutinyPdffData, setScrutinyPdffData] = useState({});
  const [ScrutinyPdffData1, setScrutinyPdffData1] = useState({});

  let navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");

  const [getOverallData, setOverallData] = useState([]);
  function finalGetAfterSubmitt(collCode) {
    let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;
        if (data && data.length > 0) {
          setPdffData2(data);
          setOverallData(res.data);
        } else {
          setOverallData([]);
        }
      })
      .catch((error) => { });
  }

  function getShiftingAddDetails(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res.data.data || [];

          if (shiftData.length > 0) {
            setPdffData3(res.data);
          }
        } else {
        }
      })
      .catch((err) => { });
  }

  const iconButn = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const previewButn = {
    ...iconButn,
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
  };


  const statusBadg = {
    backgroundColor: "#dcfce7",
    color: "#15803d",
    padding: "4px 10px",
    borderRadius: "20px",
    fontSize: "12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
  };

  function getInspectPdf(collCode, nocType) {
    CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType}`)
      .then((res) => {
        const base64Pdf = res?.data?.pdf;

        if (base64Pdf) {
          downloadBase64Pdf(base64Pdf, `${collCode}_inspection_report.pdf`);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }
  async function openNewCollegeScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating scrutiny report PDF...</p>");
    try {
      const [collegeResponse, scrutinyResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`),
      ]);

      const clgDetails = collegeResponse?.data || {};
      const scrutinyData = scrutinyResponse?.data || {};

      setScrutinyPdffData(clgDetails);
      setScrutinyPdffData1(scrutinyData);
      setSelecteddRow(row);

      await openScrutinyPdfInNewTab({ clgDetails, scrutinyData, rowData: row, previewWindow });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open scrutiny report PDF", error);
      failureAlert("Failed to generate scrutiny report PDF.");
    }
  }

  const [getSurvey, setSurvey] = useState([]);
  const getSurveyNumberr = async (collCode) => {
    let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res && res.data.status === true) {
        setSurvey(res.data.data[0] || res.data.data || []);
      } else {
        setSurvey([]);
      }
    } catch (err) {
      console.error("Error fetching survey number:", err);
      setSurvey([]);
    }
  };

  async function openManagementScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }

    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }

    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating management scrutiny report PDF...</p>");

    try {
      const [societyResponse, accommodationResponse, managementResponse, previewResponse, scrutinyDetailsResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getSocietyNameChangeinspection/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getAccommodationAreaData/${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getManagementScrutiny?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getPreView?collCode=${collCode}&nocType=management`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetails/${collCode}/management`),
      ]);

      // const collegeData = collegeResponse?.data || {};
      const societyData = societyResponse?.data?.societyName_status === true ? societyResponse?.data?.societyName || [] : [];
      const accommodationData = accommodationResponse?.data?.status === true ? accommodationResponse?.data?.data || [] : [];
      const managementPayload = managementResponse?.data?.scode === "01" ? managementResponse?.data || {} : {};
      const previewData = previewResponse?.data?.scode === "01" ? previewResponse?.data || {} : {};
      const scrutinyDetails = scrutinyDetailsResponse?.data?.status === true ? scrutinyDetailsResponse?.data || {} : {};

      // setPdfData1(collegeData);
      setSocietyName(societyData);
      // setAccomodation(accommodationData);
      setManagementData(managementPayload);
      setNocdta(previewData);
      // setSelecteddRow(row);

      await openChangeOfManagementPdfInNewTab({
        collCode,
        societyName: societyData,
        formValues: {},
        managementData: managementPayload,
        scrutinyDetails,
        mngmtScrutiny: managementPayload?.mngmtScrutiny || [],
        deficiencies: managementPayload?.mngmtScrutiny_def || [],
        accommodationRows: managementPayload?.mngmtScrutiny_accom || [],
        accommodationBaseRows: accommodationData,
        corpusFundInstall: scrutinyDetails?.corpusFundInstall || [],
        ugPrograms: scrutinyDetails?.ugCourses || [],
        pgPrograms: scrutinyDetails?.pgCourses || [],
        ugCorpusFunds: [],
        pgBefore: [],
        pgCorpusFunds: [],
        nocdta: previewData,
        parking: {},
        previewWindow,
      });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open management scrutiny report PDF", error);
      failureAlert("Failed to generate management scrutiny report PDF.");
    }
  }

  function getGovtStatusFile(row) {
    return row?.final_pdf_sign || "";
  }

  function hasGovtStatusFile(row) {
    const govtStatusFile = getGovtStatusFile(row);
    return govtStatusFile !== null && govtStatusFile !== undefined && String(govtStatusFile).trim() !== "";
  }

  function handlePost(row, index) {
    const rowValues = degreeUniFormik.values?.collegesTableData?.[index] || {};
    const govtFile = rowValues.govtFile || null;
    const isJdAdmin = userId === "jd_admin";
    const isSectionAdmin = userId === "section_admin";

    let payload;

    if (isSectionAdmin) {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        finalStatusPhase2: rowValues.final_status_phase2 || "",
        finalPdfPhase2: row.final_pdf_sign,
        finalPdfSignPhase2: govtFile,
      };
    } else {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        inspDefStatus: row.insp_final_status_def || "",
        // jdStatus: rowValues.jdStatus || "",
        jdStatusPhase2: rowValues.jdStatusPhase2 || "",
      };
    }
    console.log("payload,", payload);
    // if (isJdAdmin && !payload.jdStatus) {
    //   failureAlert("Please select JD Status");
    //   return;
    // }

    // const endpoint = userId === "section_admin" ? "updatesectionstatus" : "updatejdstatus";
    const endpoint = userId === "section_admin" ? "updatesectionstatusPhase2" : "updatejdstatusPhase2";

    CommonAxiosPost(`${config.url.FAC_URL}${endpoint}`, payload)
      .then((res) => {
        if (res?.data?.ResponseCode === "01" || res?.data?.status === true) {
          successAlert2(res?.data?.ResponseDesc || "Submitted successfully");
          GetInspectionStatus();
          degreeUniFormik.setFieldValue("collegesTableData", []);
        } else {
          failureAlert(res?.data?.sdesc || "Failed to submit");
        }
      })
      .catch(() => {
        failureAlert("Something went wrong!");
      });
  }

  const DefInspColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },
    {
      id: "mobile_email",
      header: "Contact Details",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>
          {row.original.mobile_no} - {row.original.email}
        </div>
      ),
    },
    {
      id: "noc_type",
      header: "NOC Type",
      accessorKey: "noc_type",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "college_preview",
      header: "College Preview",
      cell: ({ row }) => {
        const clgcode = row.original;
        const nocType = row.original.noc_type?.toLowerCase();
        const isNewCollege = nocType === "new_college";
        const collCode = row.original.coll_code;
        return (
          <button
            style={previewButn}
            title="View College"
            onClick={() => {
              if (isNewCollege) {
                setSelectedColCode(collCode);
                setShowPreview(true);
              } else {
                navigate("/CollegeDetails", { state: { clgcode } });
              }
            }}
          >
            <FaEye />
          </button>
        );
      },
    },
    {
      id: "inspection_preview",
      header: "Inspection Preview",
      cell: ({ row }) => {
        const nocType = row.original.noc_type?.toLowerCase();
        const collCode = row.original.coll_code;

        const isShifting = nocType === "shifting";
        const isEOP = nocType === "eop";
        const isNewCollege = nocType === "new_college";
        const isManagement = nocType === "management";

        const handleView = async () => {
          if (isShifting) {
            setSelectedColCode(collCode);
            setShowShiftinggModal(true);
            getShiftingScrutinyDetails(collCode, nocType);
            finalGetAfterSubmitt(collCode);
            setSelecteddRow(row.original);
            getSurveyNumberr(collCode);
            getShiftingAddDetails(collCode);
            getShiftingAddDetailsss(collCode);
          } else if (isEOP) {
            getInspectPdf(collCode, nocType);
          } else if (isNewCollege) {
            openNewCollegeScrutinyPdf(row.original);
          } else if (isManagement) {
            openManagementScrutinyPdf(row.original);
          } else {
            setSelecteddRow(row.original);
          }
        };

        return (
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button
              style={previewButn}
              onClick={handleView}
              title={isShifting ? "View Shifting Scrutiny" : isEOP ? "View Inspection PDF" : isManagement ? "View Management Scrutiny" : "View Inspection"}
            >
              <FaEye />
            </button>
          </div>
        );
      },
    },
    // ==================== PHASE 1 GROUP ====================
    {
      id: "phase1_group",
      header: "Phase 1",
      columns: [
        {
          id: "status",
          header: userId === "section_admin" ? "JD Status" : "Status",
          accessorKey: userId === "section_admin" ? "jd_status" : "final_status",
          meta: { style: { textAlign: "center" } },
          cell: ({ row }) => {
            return (
              <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                <span style={statusBadg}>
                  {userId === "jd_admin" && (
                    <>
                      Assigned to {row?.original?.user_name}-{row?.original?.user_id}{" "}
                    </>
                  )}
                  <FaCheckCircle />{" "}
                  {userId === "section_admin"
                    ? row.original.jd_status
                    : row.original.final_status === "Deficiencies Identified"
                      ? "Deficiency Identified"
                      : row.original.final_status === "NoDeficienciesIdentified"
                        ? " No Deficiencies Identified"
                        : row.original.final_status === "Rejected"
                          ? "Rejected"
                          : row.original.final_status}
                </span>
              </div>
            );
          },
        },
        ...(userId === "jd_admin"
          ? [
            {
              id: "jd_status",
              header: "JD Status",
              cell: ({ row }) => {
                const index = row.index;
                const jdStatus = row.original.jd_status;
                const hasSubmittedStatus = jdStatus !== null && jdStatus !== undefined && String(jdStatus).trim() !== "";

                if (hasSubmittedStatus) {
                  const normalizedStatus = String(jdStatus).trim().toLowerCase();
                  const statusLabel = normalizedStatus === "approved" ? "Approved" : normalizedStatus === "Deficiencies Identified" ? "Deficiencies Identified" : row.original.jd_status;
                  const statusColor = normalizedStatus === "approved" ? "#15803d" : normalizedStatus === "Deficiencies Identified" ? "#dc2626" : "";
                  return (
                    <div style={{ minWidth: "180px", fontWeight: 600, color: statusColor, textAlign: "center" }}>
                      <FaCheck /> {statusLabel}
                    </div>
                  );
                }

                return (
                  <div style={{ minWidth: "180px" }}>
                    <Field as="select" name={`collegesTableData[${index}].jdStatus`} className="form-control">
                      <option value="">Select</option>
                      <option value="Approved">APPROVE</option>
                      <option value="Deficiencies Identified">DEFICIENCIES IDENTIFIED</option>
                    </Field>
                  </div>
                );
              },
            },
          ]
          : userId === "section_admin"
            ? [
              {
                id: "final_status",
                header: "Status",
                cell: ({ row }) => {
                  const index = row.index;
                  return (
                    <div style={{ minWidth: "180px" }}>
                      {
                        row.original.final_status === null ? (
                          <select
                            className="form-control"
                            name={`collegesTableData[${index}].final_status`}
                            value={degreeUniFormik?.values?.collegesTableData?.[index]?.final_status || ""}
                            onChange={(e) => {
                              degreeUniFormik.setFieldValue(`collegesTableData[${index}].final_status`, e.target.value);
                            }}
                            disabled={!!degreeUniFormik?.values?.collegesTableData?.[index]?.final_status}
                          >
                            <option value="">-- Select --</option>
                            <option value="Approved">APPROVE</option>
                          </select>
                        ) : (
                          row.original.final_status
                        )
                      }
                    </div>
                  );
                },
              },
            ]
            : []),
        // Action Column
        {
          id: "action",
          header: "Action",
          cell: ({ row }) => {
            const jdStatus = row.original.jd_status;
            const hasJdStatus = jdStatus !== null && jdStatus !== undefined && String(jdStatus).trim() !== "";

            if (userId === "jd_admin" && hasJdStatus) {
              return (
                <span style={{ color: "#15803d", fontSize: "13px", fontWeight: 600, display: "inline-block" }}>
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            if (userId === "section_admin" && row.original.final_status) {
              return (
                <span style={{ color: "#15803d", fontSize: "13px", fontWeight: 600, display: "inline-block" }}>
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            return (
              <button
                type="button"
                // onClick={() => handlePost(row.original, row.index)}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Submit
              </button>
            );
          },
        },
      ],
    },

    // ==================== PHASE 2 GROUP ====================
    {
      id: "phase2_group",
      header: "Phase 2",
      columns: [
        // Phase 2 Status Column - Display only (no dropdown for section_admin here)
        {
          id: "status_phase2",
          header: userId === "section_admin" ? "JD Status" : "Status",
          accessorKey: userId === "section_admin" ? "jd_status_phase2" : "insp_final_status_def",
          meta: { style: { textAlign: "center" } },
          cell: ({ row }) => {
            return (
              <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                <span style={statusBadg}>
                  {userId === "jd_admin" && (
                    <>
                      Assigned to {row?.original?.def_insp_name}-{row?.original?.def_insp_id}{" "}
                    </>
                  )}
                  <FaCheckCircle />{" "}
                  {userId === "section_admin"
                    ? row.original.jd_status_phase2
                    : (row.original.insp_final_status_def === "Deficiencies Identified" || row.original.insp_final_status_def === "DeficiencyIdentified")
                      ? "Deficiency Identified"
                      : row.original.insp_final_status_def === "NoDeficienciesIdentified"
                        ? " No Deficiencies Identified"
                        : row.original.insp_final_status_def === "Rejected"
                          ? "Rejected"
                          : row.original.insp_final_status_def}
                </span>
              </div>
            );
          },
        },

        // Phase 2 Status Column for section_admin (dropdown for selecting status)
        ...(userId === "section_admin"
          ? [
            {
              id: "final_status_phase2",
              header: "Status",
              cell: ({ row }) => {
                const index = row.index;
                const finalStatusPhase2 = row.original.final_status_phase2;
                const hasSubmittedStatus = finalStatusPhase2 !== null && finalStatusPhase2 !== undefined && String(finalStatusPhase2).trim() !== "";

                if (hasSubmittedStatus) {
                  const normalizedStatus = String(finalStatusPhase2).trim().toLowerCase();
                  const statusLabel = normalizedStatus === "approved" ? "Approved" : normalizedStatus === "deficiencies identified" ? "Deficiencies Identified" : row.original.final_status_phase2;
                  const statusColor = normalizedStatus === "approved" ? "#15803d" : normalizedStatus === "deficiencies identified" ? "#dc2626" : "";
                  return (
                    <div style={{ minWidth: "180px", fontWeight: 600, color: statusColor, textAlign: "center" }}>
                      <FaCheck /> {statusLabel}
                    </div>
                  );
                }

                return (
                  <div style={{ minWidth: "180px" }}>
                    <Field as="select" name={`collegesTableData[${index}].final_status_phase2`} className="form-control">
                      <option value="">Select</option>
                      <option value="Forwarded">Forward</option>
                      {/* <option value="Deficiencies Identified">DEFICIENCIES IDENTIFIED</option> */}
                    </Field>
                  </div>
                );
              },
            },
          ]
          : []),

        // Phase 2 JD Status Column (only for jd_admin)
        ...(userId === "jd_admin"
          ? [
            {
              id: "jd_status_phase2",
              header: "JD Status",
              cell: ({ row }) => {
                const index = row.index;
                const jdStatusPhase2 = row.original.jd_status_phase2;
                const hasSubmittedStatus = jdStatusPhase2 !== null && jdStatusPhase2 !== undefined && String(jdStatusPhase2).trim() !== "";

                if (hasSubmittedStatus) {
                  const normalizedStatus = String(jdStatusPhase2).trim().toLowerCase();
                  const statusLabel = normalizedStatus === "approved" ? "Approved" : normalizedStatus === "Deficiencies Identified" ? "Deficiencies Identified" : row.original.jd_status_phase2;
                  const statusColor = normalizedStatus === "approved" ? "#15803d" : normalizedStatus === "Deficiencies Identified" ? "#dc2626" : "";
                  return (
                    <div style={{ minWidth: "180px", fontWeight: 600, color: statusColor, textAlign: "center" }}>
                      <FaCheck /> {statusLabel}
                    </div>
                  );
                }

                return (
                  <div style={{ minWidth: "180px" }}>
                    <Field as="select" name={`collegesTableData[${index}].jdStatusPhase2`} className="form-control">
                      <option value="">Select</option>
                      <option value="Approved">APPROVED</option>
                      <option value="Deficiencies Identified">DEFICIENCIES IDENTIFIED</option>
                      <option value="Conditionally Approved">CONDITIONALLY APPROVED</option>

                    </Field>
                  </div>
                );
              },
            },
          ]
          : []),

        // Phase 2 Action Column
        {
          id: "Phase2-action",
          header: "Action",
          cell: ({ row }) => {
            const jdStatusPhase2 = row.original.jd_status_phase2;
            const hasJdStatusPhase2 = jdStatusPhase2 !== null && jdStatusPhase2 !== undefined && String(jdStatusPhase2).trim() !== "";

            // For section_admin - check if final_status_phase2 is submitted
            const finalStatusPhase2 = row.original.final_status_phase2;
            const hasFinalStatusPhase2 = finalStatusPhase2 !== null && finalStatusPhase2 !== undefined && String(finalStatusPhase2).trim() !== "";

            if (userId === "jd_admin" && hasJdStatusPhase2) {
              return (
                <span style={{ color: "#15803d", fontSize: "13px", fontWeight: 600, display: "inline-block" }}>
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            if (userId === "section_admin" && hasFinalStatusPhase2) {
              return (
                <span style={{ color: "#15803d", fontSize: "13px", fontWeight: 600, display: "inline-block" }}>
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            return (
              <button
                type="button"
                onClick={() => handlePost(row.original, row.index)}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Submit
              </button>
            );
          },
        },
      ],
    },

  ];

  const [inspstatus, setInspStatus] = useState([]);

  function GetInspectionStatus() {
    // const endpoint = userId === "section_admin" ? "getsectionadmindata" : "getInspectionStatus";
    const endpoint = userId === "section_admin" ? "getInspectionStatusdeficiencysection" : "getInspectionStatusdeficiency";
    CommonAxiosGet(`${config.url.FAC_URL}${endpoint}`).then((res) => {
      setInspStatus(res?.data?.scode === "01" ? res.data.data || [] : []);
      const fetchedData = res.data.data || [];
      const initialTableData = fetchedData.map((row) => ({
        ...row,
        final_status: row.final_status || "", // ensure field exists
        jdStatus: row.jd_status || "", // if needed for JD admin
      }));
      degreeUniFormik.setFieldValue("collegesTableData", initialTableData);
    });
  }

  const degreeUniFormik = useFormik({
    initialValues: { collegesTableData: [], nocType: "eop" },
    onSubmit: (values) => { },
  });

  const nocTypeOptions = Array.from(new Set((inspstatus || []).map((item) => item?.noc_type).filter((item) => item !== null && item !== undefined && String(item).trim() !== "")));

  const filteredInspectionStatus = degreeUniFormik.values.nocType
    ? inspstatus.filter((item) => String(item?.noc_type || "").toLowerCase() === String(degreeUniFormik.values.nocType).toLowerCase())
    : inspstatus;



  useEffect(() => {
    GetInspectionStatus();
  }, []);
  const [shiftAddr, setShiftAddr] = useState([]);
  function getShiftingAddDetailsss(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res?.data?.data || [];
          setShiftAddr(shiftData?.length > 0 && shiftData !== "No data found" ? shiftData : []);
          if (shiftData.length > 0) {
            const firstShift = shiftData[0];
            setShiftAddr({
              new_mandal: firstShift.mandal_name || firstShift.new_mandal,
              new_district: firstShift.new_dist || firstShift.new_district,
              new_pincode: firstShift.new_pincode,
              address_ofnew_location: firstShift.address_ofnew_location,
              shift_type: firstShift.shift_type,
              distance_from_existing: firstShift.distance_from_existing,
              justification: firstShift.justification,
            });
          }
        } else {
          setShiftAddr([]);
        }
      })
      .catch((err) => {
        setShiftAddr([]);
      });
  }

  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        {showPreview ? (
          <NewCollegeApplPreview collCode={selectedColCode} />
        ) : (
          <FormikProvider value={degreeUniFormik}>
            <Form onSubmit={degreeUniFormik.handleSubmit} className="affl-form">
              <bie.Row className="px-2 pt-3 mb-3 w-100">
                <h5 className="mb-3 innerheader-new">
                  <span>Inspection Status</span>
                </h5>
                <div
                  style={{
                    minWidth: "280px",
                    maxWidth: "420px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    className="form-label mb-0"
                    style={{
                      color: "#0f766e",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      marginBottom: 0,
                    }}
                  >
                    Select NOC Type
                  </label>
                  <Field
                    as="select"
                    name="nocType"
                    className="form-control"
                    onChange={degreeUniFormik.handleChange}
                    style={{
                      minWidth: "170px",
                      maxWidth: "220px",
                      borderRadius: "10px",
                      boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
                    }}
                  >
                    <option value="">--Select--</option>
                    {nocTypeOptions?.map((nocType) => (
                      <option key={nocType} value={nocType}>
                        {nocType}
                      </option>
                    ))}
                  </Field>
                </div>
                <bie.Col xs={12}>
                  {filteredInspectionStatus?.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <CommonReactTable
                          data={filteredInspectionStatus}
                          columns={DefInspColumns}
                          filename="AsiignInspectionToByUniversity"
                          headerName={`Inspection Status`}
                          // toolbarLeftContent={nocTypeFilter}
                          showFooter={false}
                          showPagination={false}
                          showExcel={true}
                          showPrint={false}
                          excelFileName="Inspection Status"
                        />
                      </div>
                    </>
                  ) : (
                    <center className="text-danger h6">*** No Data Found ***</center>
                  )}
                </bie.Col>

                <bie.Modal show={showShiftinggModal} onHide={() => setShowShiftinggModal(false)} size="xl" scrollable>
                  <bie.Modal.Header closeButton>
                    <bie.Modal.Title>{selecteddRow?.noc_type === "shifting" && "Shifting Scrutiny Report"}</bie.Modal.Title>
                  </bie.Modal.Header>
                  <bie.Modal.Body>
                    {selecteddRow?.noc_type === "shifting" && (
                      <CollegeReport apiData={pdfData1} apiData2={pdffData2} rowData={selecteddRow} getOverallData={getOverallData} getSurvey={getSurvey} newAddData={shiftAddr} />
                    )}
                  </bie.Modal.Body>
                </bie.Modal>
              </bie.Row>
            </Form>
          </FormikProvider>
        )}
      </bie.Container>
    </>
  );
}
